module.exports = __webpack_public_path__ + "static/assets/6b4c7434da0f872e47f75f8b90b1c81d.png";